import { CompanySetupContext } from '@company/contexts/CompanySetupContext';
import { Select } from '@components/utility/selects';
import TextField from '@mui/material/TextField/TextField';
import { useGetSalesManagersQuery } from '@services/accounts';
import { useGetCountriesQuery } from '@services/countries';
import { useContext } from 'react';

const InformationStep = () => {
    const {
        formik: { values, handleChange, touched, handleBlur, errors },
    } = useContext(CompanySetupContext);
    const { data: countries } = useGetCountriesQuery();
    const { data: salesManagers } = useGetSalesManagersQuery(undefined, {
        selectFromResult: (response) => ({
            ...response,
            data: response.data?.map((user) => ({ label: user.full_name, value: user.id })) ?? [],
        }),
    });

    return (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            <TextField
                name="address"
                fullWidth
                label="Address"
                value={values.address ?? ''}
                required
                onChange={handleChange}
                error={touched.address && Boolean(errors.address)}
                helperText={touched.address && errors.address}
                onBlur={handleBlur}
            />
            <TextField
                name="city"
                fullWidth
                label="City"
                required
                value={values.city ?? ''}
                onChange={handleChange}
                error={touched.city && Boolean(errors.city)}
                helperText={touched.city && errors.city}
                onBlur={handleBlur}
            />
            <Select
                searchable
                fcSX={{ required: true }}
                required
                label="Country"
                name="country_code"
                items={countries?.map((x) => ({ label: x.label, value: x.value })) ?? []}
                value={values.country_code ?? ''}
                error={touched.country_code && Boolean(errors.country_code)}
                helperText={touched.country_code && errors.country_code}
                onChange={handleChange}
                virtualize
                type="default"
                multiple={false}
            />
            <TextField
                name="province"
                fullWidth
                label="State/Province"
                value={values.province ?? ''}
                onChange={handleChange}
                error={touched.province && Boolean(errors.province)}
                helperText={touched.province && errors.province}
                onBlur={handleBlur}
            />
            <TextField
                name="phone_number"
                fullWidth
                label="Phone"
                value={values.phone_number ?? ''}
                onChange={handleChange}
                error={touched.phone_number && Boolean(errors.phone_number)}
                helperText={touched.phone_number && errors.phone_number}
                onBlur={handleBlur}
            />
            <TextField
                name="fax_number"
                fullWidth
                label="Fax"
                value={values.fax_number ?? ''}
                onChange={handleChange}
                error={touched.fax_number && Boolean(errors.fax_number)}
                helperText={touched.fax_number && errors.fax_number}
                onBlur={handleBlur}
            />
            <TextField
                name="commercial_email"
                fullWidth
                label="Commercial contact email"
                value={values.commercial_email ?? ''}
                onChange={handleChange}
                required
                error={touched.commercial_email && Boolean(errors.commercial_email)}
                helperText={touched.commercial_email && errors.commercial_email}
                onBlur={handleBlur}
            />
            <TextField
                name="support_emails"
                fullWidth
                label="Technical support contact email"
                value={values.support_emails ?? ''}
                onChange={handleChange}
                inputMode="email"
                required
                error={touched.support_emails && Boolean(errors.support_emails)}
                helperText={touched.support_emails && errors.support_emails}
                onBlur={handleBlur}
            />
            <TextField
                name="website"
                fullWidth
                label="Website"
                value={values.website ?? ''}
                onChange={handleChange}
                error={touched.website && Boolean(errors.website)}
                helperText={touched.website && errors.website}
                onBlur={handleBlur}
            />
            <Select
                searchable
                label="Sales Manager"
                name="sales_manager_id"
                items={salesManagers}
                value={values.sales_manager_id ?? ''}
                onChange={handleChange}
                virtualize
                type="default"
            />
        </div>
    );
};

export { InformationStep };
